export enum SettingsTabsType {
  Header,
  Sharing,
}

export interface SettingsTab {
  type: SettingsTabsType;
  name: string;
}
export const HEADER_TAB: SettingsTab = {
  type: SettingsTabsType.Header,
  name: 'Header',
};
export const SHARING_TAB: SettingsTab = {
  type: SettingsTabsType.Sharing,
  name: 'Sharing',
};
